module.exports = __webpack_public_path__ + "assets/img/nanning.571b5ebb.png";